export var Urls = {
    FlushCache: "CacheManagement/FlushCache"
};
